<template>
  <b-modal id="modal-cannot-delete-header-menu" header-class="warning">
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <TitleModal :tag="'div'" :label="$t('engine.manageHeader.widgetMenu.warningDeleteMenu.lblTitle', languageEngine)" />
      </div>
      <div
        @click="closeModal()"
        type="button"
        aria-label="Close"
        class="icon-close-modal"
      >
        <i class="fal fa-times"></i>
      </div>
    </template>
    <template>
      <div class="fs-sa-16">
        {{$t('engine.manageHeader.widgetMenu.warningDeleteMenu.lblDetail', languageEngine)}}
      </div>
    </template>
    <template #modal-footer>
      <div class="float-right">
        <b-button variant="default" class="fs-sa-14" @click="closeModal">{{$t('engine.manageHeader.widgetMenu.warningDeleteMenu.lblBtnClose', languageEngine)}}</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";

export default {
  components: {
    TitleModal
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
    }),
  },
  methods: {
    closeModal() {
      this.$bvModal.hide("modal-cannot-delete-header-menu");
    }
  },
}
</script>
<style lang="scss">
#modal-cannot-delete-header-menu {
  .modal-header {
    padding: 16px 24px;
    display: flex;
    align-items: center;
    .icon-close-modal {
      font-size: 24px;
      width: 16px;
      height: 24px;
      color: rgba(0, 0, 0, 0.5);
      svg { 
        position: absolute;
      }
    }
  }
  .modal-body {
    padding: 24px;
    display: flex;
    align-items: center;
  }
  .modal-footer {
    padding: 16px 24px;
    display: flex;
    align-items: center;
  }
}
</style>